import styled from 'styled-components/native';

const Wrapper = styled.View`
    background-color: #ffff;
    height: 100%;
`;

export default Wrapper;
